export type QuestionOverlayVisibilityEvent =
  | { type: 'peek-button-click' }
  | { type: 'tab-down' }
  | { type: 'tab-up' }
  | { type: 'question-backdrop-click' }
  | { type: 'question-card-click' };

export const getQuestionOverlayVisibility = (
  isVisible: boolean,
  event: QuestionOverlayVisibilityEvent
): boolean => {
  switch (event.type) {
    case 'peek-button-click':
    case 'tab-down':
      return true;
    case 'tab-up':
    case 'question-backdrop-click':
      return false;
    case 'question-card-click':
      return isVisible;
  }
};
